// #413 — which of the given events does any cached events list show as Seen? The Suspicious toasts close on this: it
// sees this tab's optimistic Seen (rows, cards, modal, toast) and a refetch after a colleague's Seen. Pure reads of the
// query cache; a page `{results}` and an infinite `{pages}` are both read.
import type { QueryClient } from '@tanstack/react-query'

type Row = { id?: unknown; seen_at?: unknown }

const rowsOf = (data: unknown): Row[] => {
  if (!data || typeof data !== 'object') return []
  const { results, pages } = data as { results?: unknown; pages?: unknown }
  if (Array.isArray(results)) return results as Row[]
  if (Array.isArray(pages)) return pages.flatMap((p) => rowsOf(p))
  return []
}

/** The ids (of `eventIds`) that any cached `['events', …]` list holds with a non-null `seen_at`. */
export function seenEventIds(queryClient: QueryClient, eventIds: number[]): number[] {
  if (eventIds.length === 0) return []
  const wanted = new Set(eventIds)
  const seen = new Set<number>()
  for (const [, data] of queryClient.getQueriesData({ queryKey: ['events'] })) {
    for (const row of rowsOf(data)) {
      if (typeof row.id === 'number' && wanted.has(row.id) && row.seen_at) seen.add(row.id)
    }
  }
  return eventIds.filter((id) => seen.has(id))
}
